import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { DetailedPropertyDataType, ResponseData } from "./common"

interface PropertyRequestData {
  propertyId: string
  avoidClientSideAuth?: boolean
}

export interface PropertyRequest extends Partial<AxiosRequestConfig> {
  params: PropertyRequestData
}

export interface PropertyResponseData extends ResponseData {
  data: DetailedPropertyDataType
}

export interface PropertyResponse extends AxiosResponse {
  data: PropertyResponseData
}

export function getPropertyDetailsApi(
  {
    params,
    method = "get",
    url = `/property/propertyId/${params.propertyId}`,
    ...config
  }: PropertyRequest,
  axiosInstance: AxiosInstance,
): Promise<PropertyResponse> {
  return axiosInstance({
    ...(params.avoidClientSideAuth
      ? {
          data: {
            avoidClientSideAuth: true, // as it is being called on server side
          },
        }
      : {}),
    method,
    url,
    ...config,
  }) as Promise<PropertyResponse>
}
